import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { FaArrowLeft, FaBookOpen } from "react-icons/fa";
import { API_BASE_URL } from "../../config/apiConfig";

const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem("token")}` });

const MyLessons = () => {
    const navigate = useNavigate();
    const [lessons, setLessons] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchLessons = async () => {
            try {
                const res = await fetch(`${API_BASE_URL}/api/lessons`, { headers: authHeaders() });
                const data = await res.json();
                setLessons(data.data || []);
            } catch (err) {
                toast.error("Could not load lessons");
            } finally {
                setLoading(false);
            }
        };
        fetchLessons();
    }, []);

    return (
        <div className="min-h-screen bg-gray-50">
            <nav className="bg-[#2148C0] shadow-md px-6 py-4 flex items-center gap-4">
                <button onClick={() => navigate("/dashboard")} className="text-white"><FaArrowLeft size={18} /></button>
                <h1 className="text-xl font-bold text-white">My Lessons</h1>
            </nav>

            <div className="max-w-3xl mx-auto p-6">
                {loading && <p className="text-gray-500">Loading...</p>}
                {!loading && lessons.length === 0 && (
                    <p className="text-gray-500">No lessons yet. Once your teacher publishes a lesson, it'll show up here.</p>
                )}
                <div className="space-y-3">
                    {lessons.map((lesson) => (
                        <button key={lesson.id} onClick={() => navigate(`/lessons/${lesson.id}`)}
                            className="w-full text-left bg-white rounded-xl shadow-sm p-4 hover:shadow-md transition flex items-center gap-4">
                            <div className="bg-blue-50 text-blue600 p-3 rounded-lg"><FaBookOpen /></div>
                            <div>
                                <h3 className="font-semibold text-gray-800">{lesson.title}</h3>
                                <p className="text-sm text-gray-500">
                                    {[lesson.subject, lesson.class, lesson.topic].filter(Boolean).join(" · ")}
                                    {lesson.segmentCount ? ` · ${lesson.segmentCount} sub-topic${lesson.segmentCount === 1 ? "" : "s"}` : ""}
                                </p>
                            </div>
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default MyLessons;
